import type { ReactNode } from "react";

type KycLayoutProps = {
  children: ReactNode;
};

const KycLayout = ({ children }: KycLayoutProps) => (
  <div className="flex gap-6 justify-center min-h-screen overflow-hidden relative">
    <div className="shrink-0 absolute top-0 left-0 -ml-28 -mt-28">
      <img src="/bg_brand.png" className="h-[700px]" alt="bg-left" />
    </div>
    <div className="flex max-h-screen w-full items-center justify-center py-12 overflow-y-auto z-10">
      <div className="overflow-y-scroll py-10">{children}</div>
    </div>
    <div className="shrink-0 absolute bottom-0 right-0 -mr-28 -mb-28">
      <img src="/bg_brand.png" className="h-[700px]" alt="bg-right" />
    </div>
  </div>
);

export default KycLayout;
